
<template>
  <div class="app-warpper">
    <template v-if="isShowLayout">
      <div class="header fixed-header">
        <nav-bar />
      </div>

      <el-scrollbar style="height: 100%" wrap-class="scrollbar-wrapper">
        <div class="main-container">
          <div class="base-warpper">
            <div class="children-container">
              <Sidebar v-show="isShowSidebar" />
              <div class="app-main" :class="isShowSidebar ? '' : 'full'">
                <Breadcrumb v-if="isShowSidebar" />

                <transition name="fade-transform" mode="out-in">
                  <router-view :key="key" :class="isShowSidebar ? 'has-aside-main-bg' : ''" />
                </transition>
              </div>
            </div>
          </div>
        </div>
        <Footer />
        <el-backtop target=".el-scrollbar__wrap" :bottom="150" />
      </el-scrollbar>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script>
import { NavBar, Sidebar, Footer } from './components'
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: {
    NavBar,
    Sidebar,
    Breadcrumb,
    // eslint-disable-next-line vue/no-reserved-component-names
    Footer
  },
  data() {
    return {
      isShowLayout: true
    }
  },
  computed: {
    key() {
      return this.$route.path
    },
    isShowSidebar() {
      if (this.$route.meta.isShowSidebar === undefined) {
        return true
      }
      return this.$route.meta.isShowSidebar
    }
  },
  created() {
    const showType = this.$store.state.app.showType
    if (showType === 'h5') {
      this.isShowLayout = false
    }
  }
}
</script>

<style lang="scss" scoped>
.app-warpper {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background-color: var(--layout-background);
}
.children-container {
  display: flex;
  // height: calc(100vh - 3 * var(--head-height));
  justify-content: space-between;
  height: auto;
  .app-main {
    width: calc(var(--base-width) - 220px);
    height: 100%;
  }
}
@media screen and (min-width: 1024px) and (max-width: 1440px) {
  .app-main {
    width: calc(1200px - 220px) !important;
    height: 100%;
  }
  .full {
    width: 1200px !important;
  }
}
.full {
  width: var(--base-width) !important;
}
.has-aside-main-bg {
  background-color: #fff;
  padding: 16px 20px;
  box-sizing: border-box;
  border-radius: 8px;
}

</style>
